exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/superimpose/superimpose.component.css
// module id = ../../../../../src/app/superimpose/superimpose.component.css
// module chunks = main